// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** Calendar view ****/

[class*='cal-cell'] {
  float: left;
  margin-left: 0;
  min-height: 1px;
}

.cal-row-fluid {
  width: 100%;
  *zoom: 1;
}

.cal-row-fluid:before,
.cal-row-fluid:after {
  display: table;
  content: '';
  line-height: 0;
}

.cal-row-fluid:after {
  clear: both;
}
.cal-row-fluid [class*='cal-cell'] {
  display: block;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  margin-left: 0%;
  *margin-left: -0.05213764337851929%;
}
.cal-row-fluid [class*='cal-cell']:first-child {
  margin-left: 0;
}
.cal-row-fluid .controls-row [class*='cal-cell'] + [class*='cal-cell'] {
  margin-left: 0%;
}
.cal-row-fluid .cal-cell7 {
  width: 100%;
  *width: 99.94669509594883%;
}
.cal-row-fluid .cal-cell6 {
  width: 85.71428571428571%;
  *width: 85.66098081023453%;
}
.cal-row-fluid .cal-cell5 {
  width: 71.42857142857142%;
  *width: 71.37526652452024%;
}
.cal-row-fluid .cal-cell4 {
  width: 57.14285714285714%;
  *width: 57.089552238805965%;
}
.cal-row-fluid .cal-cell3 {
  width: 42.857142857142854%;
  *width: 42.80383795309168%;
}
.cal-row-fluid .cal-cell2 {
  width: 28.57142857142857%;
  *width: 28.518123667377395%;
}
.cal-row-fluid .cal-cell1 {
  width: 14.285714285714285%;
  *width: 14.232409381663112%;
}
.cal-week-box .cal-offset7,
.cal-row-fluid .cal-offset7,
.cal-row-fluid .cal-offset7:first-child {
  margin-left: 100%;
  *margin-left: 99.89339019189765%;
}
.cal-week-box .cal-offset6,
.cal-row-fluid .cal-offset6,
.cal-row-fluid .cal-offset6:first-child {
  margin-left: 85.71428571428571%;
  *margin-left: 85.60767590618336%;
}
.cal-week-box .cal-offset5,
.cal-row-fluid .cal-offset5,
.cal-row-fluid .cal-offset5:first-child {
  margin-left: 71.42857142857142%;
  *margin-left: 71.32196162046907%;
}
.cal-week-box .cal-offset4,
.cal-row-fluid .cal-offset4,
.cal-row-fluid .cal-offset4:first-child {
  margin-left: 57.14285714285714%;
  *margin-left: 57.03624733475479%;
}
.cal-week-box .cal-offset3,
.cal-row-fluid .cal-offset3,
.cal-row-fluid .cal-offset3:first-child {
  margin-left: 42.857142857142854%;
  *margin-left: 42.750533049040506%;
}
.cal-week-box .cal-offset2,
.cal-row-fluid .cal-offset2,
.cal-row-fluid .cal-offset2:first-child {
  margin-left: 28.57142857142857%;
  *margin-left: 28.46481876332622%;
}
.cal-week-box .cal-offset1,
.cal-row-fluid .cal-offset1,
.cal-row-fluid .cal-offset1:first-child {
  margin-left: 14.285714285714285%;
  *margin-left: 14.17910447761194%;
}
.cal-row-fluid .cal-cell1 {
  width: 14.285714285714285%;
  *width: 14.233576642335766%;
}
[class*='cal-cell'].hide,
.cal-row-fluid [class*='cal-cell'].hide {
  display: none;
}
[class*='cal-cell'].pull-right,
.cal-row-fluid [class*='cal-cell'].pull-right {
  float: right;
}
.cal-row-head [class*='cal-cell']:first-child,
.cal-row-head [class*='cal-cell'] {
  min-height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cal-events-num {
  margin-top: 20px;
}
.cal-month-day {
  position: relative;
  display: block;
  width: 100%;
}
#cal-week-box {
  position: absolute;
  width: 70px;
  left: -71px;
  top: -1px;
  padding: 8px 5px;
  cursor: pointer;
}
#cal-day-tick {
  position: absolute;
  right: 50%;
  bottom: -21px;
  padding: 0px 5px;
  cursor: pointer;
  z-index: 5;
  text-align: center;
  width: 26px;
  margin-right: -17px;
}
.cal-year-box #cal-day-tick {
  margin-right: -7px;
}
#cal-slide-box {
  position: relative;
}
#cal-slide-tick {
  position: absolute;
  width: 16px;
  margin-left: -7px;
  height: 9px;
  top: -1px;
  z-index: 1;
}
#cal-slide-tick.tick-month1 {
  left: 12.5%;
}
#cal-slide-tick.tick-month2 {
  left: 37.5%;
}
#cal-slide-tick.tick-month3 {
  left: 62.5%;
}
#cal-slide-tick.tick-month4 {
  left: 87.5%;
}
#cal-slide-tick.tick-day1 {
  left: 7.14285714285715%;
}
#cal-slide-tick.tick-day2 {
  left: 21.42857142857143%;
}
#cal-slide-tick.tick-day3 {
  left: 35.71428571428572%;
}
#cal-slide-tick.tick-day4 {
  left: 50%;
}
#cal-slide-tick.tick-day5 {
  left: 64.2857142857143%;
}
#cal-slide-tick.tick-day6 {
  left: 78.57142857142859%;
}
#cal-slide-tick.tick-day7 {
  left: 92.85714285714285%;
}
#cal-slide-content ul.unstyled {
  margin-bottom: 0;
}
.cal-week-box {
  position: relative;
}
.cal-week-box [data-event-class] {
  white-space: nowrap;
  height: 30px;
  margin: 1px 1px;
  line-height: 30px;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 10px;
}
.cal-week-box .cal-column {
  position: absolute;
  height: 100%;
  z-index: -1;
}
.cal-week-box .arrow-before,
.cal-week-box .arrow-after {
  position: relative;
}
.cal-week-box .arrow-after:after {
  content: '';
  position: absolute;
  top: 0px;
  width: 0;
  height: 0;
  right: 0;
  border-top: 15px solid #ffffff;
  border-left: 8px solid;
  border-bottom: 15px solid #ffffff;
}
.cal-week-box .arrow-before:before {
  content: '';
  position: absolute;
  top: 0px;
  width: 0;
  height: 0;
  left: 1px;
  border-top: 15px solid transparent;
  border-left: 8px solid #ffffff;
  border-bottom: 15px solid transparent;
}
#cal-day-box {
  text-wrap: none;
}
#cal-day-box .cal-day-hour-part {
  height: 30px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-bottom: thin dashed #e1e1e1;
}
#cal-day-box .cal-day-hour .day-highlight {
  height: 30px;
}
#cal-day-box .cal-hours {
  font-weight: bolder;
}
#cal-day-box .cal-day-hour:nth-child(odd) {
  background-color: #fafafa;
}
#cal-day-box #cal-day-panel {
  position: relative;
  padding-left: 60px;
}
#cal-day-box #cal-day-panel-hour {
  position: absolute;
  width: 100%;
  margin-left: -60px;
}
#cal-day-box .day-event {
  position: relative;
  max-width: 200px;
  overflow: hidden;
}
#cal-day-box .day-highlight {
  line-height: 30px;
  padding-left: 8px;
  padding-right: 8px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border: 1px solid #c3c3c3;
  margin: 1px 1px;
  overflow: hidden;
  text-overflow: ellipsis;
}
#cal-day-box .day-highlight.dh-event-important {
  border: 1px solid #ad2121;
}
#cal-day-box .day-highlight.dh-event-warning {
  border: 1px solid #e3bc08;
}
#cal-day-box .day-highlight.dh-event-info {
  border: 1px solid #1e90ff;
}
#cal-day-box .day-highlight.dh-event-inverse {
  border: 1px solid #1b1b1b;
}
#cal-day-box .day-highlight.dh-event-success {
  border: 1px solid #006400;
}
#cal-day-box .day-highlight.dh-event-special {
  background-color: #ffe6ff;
  border: 1px solid #800080;
}
.event {
  display: block;
  background-color: #c3c3c3;
  width: 12px;
  height: 12px;
  margin-right: 2px;
  margin-bottom: 2px;
  -webkit-box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.4);
  box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  border: 1px solid #ffffff;
}
.event-block {
  display: block;
  background-color: #c3c3c3;
  width: 20px;
  height: 100%;
}
.cal-event-list .event.pull-left {
  margin-top: 3px;
}
.event-important {
  background-color: #ad2121;
}
.event-info {
  background-color: #1e90ff;
}
.event-warning {
  background-color: #e3bc08;
}
.event-inverse {
  background-color: #1b1b1b;
}
.event-success {
  background-color: #006400;
}
.event-special {
  background-color: #800080;
}
.day-highlight {
  background-color: #dddddd;
}
.day-highlight.dh-event-important {
  background-color: #fae3e3;
}
.day-highlight.dh-event-warning {
  background-color: #fdf1ba;
}
.day-highlight.dh-event-info {
  background-color: #d1e8ff;
}
.day-highlight.dh-event-inverse {
  background-color: #c1c1c1;
}
.day-highlight.dh-event-success {
  background-color: #caffca;
}
.day-highlight.dh-event-special {
  background-color: #ffe6ff;
}
.cal-row-head [class*='cal-cell']:first-child,
.cal-row-head [class*='cal-cell'] {
  text-align: center;
  border: 0px solid;
  padding: 5px 0;
}
.cal-row-head [class*='cal-cell'] small {
  font-weight: normal;
}

.cal-month-day {
  height: 100px;
}
[class*='cal-cell']:hover {
  background-color: #ededed;
}
.cal-row-fluid .week .cal-cell1.cal-cell,
.cal-row-fluid .week .cal-cell1.cal-cell:hover {
  background-color: #fff;
  color: #000;
}

.cal-year-box [class*='span'],
.cal-month-box [class*='cal-cell'] {
  min-height: 13vh; /* was 100px sean neilan */
  border-right: 1px solid #e1e1e1;
  position: relative;
}
.cal-year-box [class*='span'] {
  min-height: 60px;
}
.cal-year-box .row-fluid [class*='span']:last-child,
.cal-month-box .cal-row-fluid [class*='cal-cell']:last-child {
  border-right: 0px;
}
.cal-year-box .row-fluid,
.cal-month-box .cal-row-fluid {
  border-bottom: 1px solid #e1e1e1;
  margin-left: 0px;
  margin-right: 0px;
}
.cal-year-box .row-fluid:last-child,
.cal-month-box .cal-row-fluid:last-child {
  border-bottom: 0px;
}
.cal-month-box,
.cal-year-box,
.cal-week-box {
  border-bottom: 1px solid #e1e1e1;
  border-left: 1px solid #e1e1e1;
  border-radius: 2px;
}
span[data-cal-date] {
  font-size: 1.2em;
  font-weight: normal;
  opacity: 0.5;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -ms-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  margin-top: 15px;
  margin-right: 15px;
}
span[data-cal-date]:hover {
  opacity: 1;
}
.cal-day-outmonth span[data-cal-date] {
  opacity: 0.1;
  cursor: default;
}
.cal-day-today {
  background-color: #e8fde7;
}
.cal-day-today span[data-cal-date] {
  color: darkgreen;
}
.cal-month-box .cal-day-today span[data-cal-date] {
  font-size: 1.9em;
}
.cal-day-holiday span[data-cal-date] {
  color: #800080;
}
.cal-day-weekend span[data-cal-date] {
  color: darkred;
}
#cal-week-box {
  border: 1px solid #e1e1e1;
  border-right: 0px;
  border-radius: 5px 0 0 5px;
  background-color: #fafafa;
  text-align: right;
}
#cal-day-tick {
  border: 1px solid #e1e1e1;
  border-top: 0px solid;
  border-radius: 0 0 5px 5px;
  background-color: #ededed;
  text-align: center;
}
#cal-slide-box {
  border-top: 0px solid #8c8c8c;
}
#cal-slide-content {
  padding: 20px;
  color: #ffffff;
  /* background-image: url("../img/dark_wood.png"); */
  -webkit-box-shadow: inset 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  box-shadow: inset 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
}
#cal-slide-tick {
  /* background-image: url("../img/tick.png?2"); */
}
#cal-slide-content:hover {
  background-color: transparent;
}
#cal-slide-content a.event-item {
  color: #ffffff;
  font-weight: normal;
  line-height: 22px;
}
.cal-column {
  border-left: 1px solid #e1e1e1;
}

a.cal-event-week {
  text-decoration: none;
  color: #151515;
}

.border-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.border-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

/**** Calendar related layout stuff ****/
/* layout for the calendar and todo list*/
.innerCalendarContainer {
  display: flex;
}

#courseCalendarHolder {
  width: 60%;
}

.calendar {
  float: left;
  display: block;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.calendar div.header {
  float: left;
  width: 100%;
  background: white !important;
  height: 40px;
  color: white;
}

.calendar div.header * {
  height: 40px;
  line-height: 40px !important;
  display: inline-block;
  float: left;
  vertical-align: middle;
}

.calendar div.header i {
  float: left;
  width: 40px;
  font-size: 1.125em;
  font-weight: bold;
  position: relative;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding: 0 11%;
  cursor: pointer;
}

.calendar div.header i.fa-angle-left {
  text-align: left;
}

.calendar div.header i.fa-angle-right {
  text-align: right;
}

.calendar div.header div {
  float: left;
  width: 100%;
  font-weight: bold;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding-left: 50px;
  padding-right: 40px;
  color: black;
}

/* Center the month selector */
.calendar div.header div.nav {
  display: flex;
  justify-content: center;
}

/* Make the month name at the top huge */
.calendar div.header div.nav span {
  font-size: 2rem;
}

.calendar div.header .filtering {
  float: right;
  width: 30%;
}

.calendar div.header .filtering span {
  display: block;
  float: right;
  margin-right: 15px;
}

/* Calendar row styling */
.calendar .cal-month-box div.week {
  border-right: solid 1px #e1e1e1;
  border-left: solid 1px #e1e1e1;
}
.calendar div.week {
  float: left;
  width: 100%;
  border-top: solid 1px #e1e1e1;
  border-bottom: none;
}
.calendar div.week:first-child {
  border-top: none;
}
.calendar div.week:last-child {
  border-bottom: solid 1px #e1e1e1;
}
.calendar div.week .cal-cell.day:first-child {
  border-left: none;
}
.calendar div.week > .day.today h5 {
  color: #1eabe3;
  font-weight: bold;
}
.calendar div.week .cal-cell.day.different-month {
  color: #c0c0c0;
}

/* If you select a different month, the gray text will look bad
 * on most selectors, so, change it to black. this gets changed to white in the css.js service if the portalBackground color is too dark */
.calendar div.week .cal-cell.day.different-month.selected {
  color: black;
}
.calendar div.week .cal-cell.day.selected {
  background: #e5e5e5;
  outline: none;
}
.calendar div.week.names div {
  color: #2875c7;
}

.calendar .calendarList .h3 a {
  font-size: 24px;
}

/* Individual cell layout */
.calendar div.week .cal-cell.day {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 0rem;
  padding-left: 0.5rem;
  padding-top: 0.7rem;
  padding-right: 0.5rem;
}

/* upper right todo bubble count */
.calendar div.week .todoCount {
  position: absolute;
  top: -1rem;
  right: -1rem;
  width: 3rem;
  height: 3rem;
  background-color: #1eabe3;
  border-radius: 10rem;
  color: white;
  font-weight: bold;
  z-index: 1;
  line-height: 30px;
  -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.33);
  box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.33);
}

/* Individual cell styling */
.calendar .calendarCellItem {
  text-align: left;
  font-weight: bold;
}
.calendar .calendarCellItem span {
  text-align: left;
  font-weight: bold;
  display: block;
  overflow: hidden;
  height: 5vh;
}

.calendar div.week > .day {
  float: left;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  text-align: center;
  height: 30px;
  line-height: 30px !important;
  display: inline-block;
  vertical-align: middle;
  background: white;
  cursor: pointer;
  color: black;
}

.calendar div.week > .day .content p {
  margin: 0;
  padding: 0px 0 3px 7px;
  line-height: 16px;
  font-size: 12px;
}

.calendar div.week > .day h5 {
  margin: 3px;
  text-align: left;
}

/**** Assignments list ****/
/* Make sure the assignments list floats to the right */
#courseCalendarAssignmentHolder {
  /* Stored in calendar.html */
  float: right;
  display: flex;
  width: 40%;
  margin-left: 1rem;
}

#calendarAssignmentsList {
  /* Background */
  background-color: #e5e5e5;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 2rem;
  overflow-y: scroll;
  width: 100%;
}

#calendarAssignmentsList h2 {
  color: black !important;
  font-size: 2rem;
  text-align: center;
  font-family: sans-serif;
  font-weight: bold;
  text-transform: uppercase;
}

#calendarAssignmentsList h3.dueDate {
  color: black !important;
  font-size: 4rem;
  text-align: center;
  font-family: sans-serif;
  font-weight: bold;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 3rem;

  /* Technical debt from a similar
    class called .dueDate in another file */
  position: initial;
  top: 0;
}

/* list style layout */
ul.todoList {
  list-style: none;
  padding-left: 1.5rem;
  padding-top: 2.5rem;
  padding-bottom: 1.5rem;
}

ul.todoList li {
  display: flex;
  justify-content: space-between;
}

/* Assignment status styling */
ul.todoList li span.status {
  font-weight: bold;
  font-size: 14px;
  font-style: italic;
  width: 23%;
}

/* Assignment title */
ul.todoList li .title {
  color: black;
  font-size: 16px;

  /* this combo makes it so we have a nice border on the left side */
  border-left: 1px solid #cccccc;
  padding-bottom: 30px;

  padding-left: 5%;
  font-weight: bold;
  width: 75%;
}

/* ILT Schedule offering */
ul.todoList li a.schedule {
  font-size: 12px;
  display: block;
  margin-top: 7px;
}

ul.todoList li .sessions {
  padding: 7px 0px 0px 15px;
}

ul.todoList li .sessions li {
  display: block;
}

ul.todoList li .sessions li p {
  font-size: 14px;
  font-weight: normal;
  width: 100%;
}

#calendarAssignmentsList .offeringDetailsTitle {
  color: black;
  font-size: 14px;
  font-weight: bold;
  width: 100%;
}

#calendarAssignmentsList .offeringDetailsValue {
  color: black;
  font-size: 14px;
  width: 75%;
  font-weight: normal;
}

#calendarAssignmentsList .dateList {
  column-gap: 3px;
}

#calendarAssignmentsList .dateList .offeringDetailsTitle {
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/calendar.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;GACX,OAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,eAAe;GACf,kCAAmC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;GACX,yBAA0B;AAC5B;AACA;EACE,yBAAyB;GACzB,yBAA0B;AAC5B;AACA;EACE,yBAAyB;GACzB,yBAA0B;AAC5B;AACA;EACE,yBAAyB;GACzB,0BAA2B;AAC7B;AACA;EACE,0BAA0B;GAC1B,yBAA0B;AAC5B;AACA;EACE,yBAAyB;GACzB,0BAA2B;AAC7B;AACA;EACE,0BAA0B;GAC1B,0BAA2B;AAC7B;AACA;;;EAGE,iBAAiB;GACjB,+BAAgC;AAClC;AACA;;;EAGE,+BAA+B;GAC/B,+BAAgC;AAClC;AACA;;;EAGE,+BAA+B;GAC/B,+BAAgC;AAClC;AACA;;;EAGE,+BAA+B;GAC/B,+BAAgC;AAClC;AACA;;;EAGE,gCAAgC;GAChC,gCAAiC;AACnC;AACA;;;EAGE,+BAA+B;GAC/B,+BAAgC;AAClC;AACA;;;EAGE,gCAAgC;GAChC,+BAAgC;AAClC;AACA;EACE,0BAA0B;GAC1B,0BAA2B;AAC7B;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,SAAS;EACT,kCAAkC;EAClC,8BAA8B;EAC9B,qCAAqC;AACvC;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,4DAA4D;EAC5D,oDAAoD;EACpD,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,gBAAgB,EAAE,0BAA0B;EAC5C,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;EAGE,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,mDAAmD;EACnD,6DAA6D;EAC7D,qDAAqD;AACvD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;0IAC0I;AAC1I;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;AACjD;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B,uDAAuD;AACvD;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;;EAEpB;2CACyC;EACzC,iBAAiB;EACjB,MAAM;AACR;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,eAAe;;EAEf,kEAAkE;EAClE,8BAA8B;EAC9B,oBAAoB;;EAEpB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/**** Calendar view ****/\n\n[class*='cal-cell'] {\n  float: left;\n  margin-left: 0;\n  min-height: 1px;\n}\n\n.cal-row-fluid {\n  width: 100%;\n  *zoom: 1;\n}\n\n.cal-row-fluid:before,\n.cal-row-fluid:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n\n.cal-row-fluid:after {\n  clear: both;\n}\n.cal-row-fluid [class*='cal-cell'] {\n  display: block;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  float: left;\n  margin-left: 0%;\n  *margin-left: -0.05213764337851929%;\n}\n.cal-row-fluid [class*='cal-cell']:first-child {\n  margin-left: 0;\n}\n.cal-row-fluid .controls-row [class*='cal-cell'] + [class*='cal-cell'] {\n  margin-left: 0%;\n}\n.cal-row-fluid .cal-cell7 {\n  width: 100%;\n  *width: 99.94669509594883%;\n}\n.cal-row-fluid .cal-cell6 {\n  width: 85.71428571428571%;\n  *width: 85.66098081023453%;\n}\n.cal-row-fluid .cal-cell5 {\n  width: 71.42857142857142%;\n  *width: 71.37526652452024%;\n}\n.cal-row-fluid .cal-cell4 {\n  width: 57.14285714285714%;\n  *width: 57.089552238805965%;\n}\n.cal-row-fluid .cal-cell3 {\n  width: 42.857142857142854%;\n  *width: 42.80383795309168%;\n}\n.cal-row-fluid .cal-cell2 {\n  width: 28.57142857142857%;\n  *width: 28.518123667377395%;\n}\n.cal-row-fluid .cal-cell1 {\n  width: 14.285714285714285%;\n  *width: 14.232409381663112%;\n}\n.cal-week-box .cal-offset7,\n.cal-row-fluid .cal-offset7,\n.cal-row-fluid .cal-offset7:first-child {\n  margin-left: 100%;\n  *margin-left: 99.89339019189765%;\n}\n.cal-week-box .cal-offset6,\n.cal-row-fluid .cal-offset6,\n.cal-row-fluid .cal-offset6:first-child {\n  margin-left: 85.71428571428571%;\n  *margin-left: 85.60767590618336%;\n}\n.cal-week-box .cal-offset5,\n.cal-row-fluid .cal-offset5,\n.cal-row-fluid .cal-offset5:first-child {\n  margin-left: 71.42857142857142%;\n  *margin-left: 71.32196162046907%;\n}\n.cal-week-box .cal-offset4,\n.cal-row-fluid .cal-offset4,\n.cal-row-fluid .cal-offset4:first-child {\n  margin-left: 57.14285714285714%;\n  *margin-left: 57.03624733475479%;\n}\n.cal-week-box .cal-offset3,\n.cal-row-fluid .cal-offset3,\n.cal-row-fluid .cal-offset3:first-child {\n  margin-left: 42.857142857142854%;\n  *margin-left: 42.750533049040506%;\n}\n.cal-week-box .cal-offset2,\n.cal-row-fluid .cal-offset2,\n.cal-row-fluid .cal-offset2:first-child {\n  margin-left: 28.57142857142857%;\n  *margin-left: 28.46481876332622%;\n}\n.cal-week-box .cal-offset1,\n.cal-row-fluid .cal-offset1,\n.cal-row-fluid .cal-offset1:first-child {\n  margin-left: 14.285714285714285%;\n  *margin-left: 14.17910447761194%;\n}\n.cal-row-fluid .cal-cell1 {\n  width: 14.285714285714285%;\n  *width: 14.233576642335766%;\n}\n[class*='cal-cell'].hide,\n.cal-row-fluid [class*='cal-cell'].hide {\n  display: none;\n}\n[class*='cal-cell'].pull-right,\n.cal-row-fluid [class*='cal-cell'].pull-right {\n  float: right;\n}\n.cal-row-head [class*='cal-cell']:first-child,\n.cal-row-head [class*='cal-cell'] {\n  min-height: auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.cal-events-num {\n  margin-top: 20px;\n}\n.cal-month-day {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n#cal-week-box {\n  position: absolute;\n  width: 70px;\n  left: -71px;\n  top: -1px;\n  padding: 8px 5px;\n  cursor: pointer;\n}\n#cal-day-tick {\n  position: absolute;\n  right: 50%;\n  bottom: -21px;\n  padding: 0px 5px;\n  cursor: pointer;\n  z-index: 5;\n  text-align: center;\n  width: 26px;\n  margin-right: -17px;\n}\n.cal-year-box #cal-day-tick {\n  margin-right: -7px;\n}\n#cal-slide-box {\n  position: relative;\n}\n#cal-slide-tick {\n  position: absolute;\n  width: 16px;\n  margin-left: -7px;\n  height: 9px;\n  top: -1px;\n  z-index: 1;\n}\n#cal-slide-tick.tick-month1 {\n  left: 12.5%;\n}\n#cal-slide-tick.tick-month2 {\n  left: 37.5%;\n}\n#cal-slide-tick.tick-month3 {\n  left: 62.5%;\n}\n#cal-slide-tick.tick-month4 {\n  left: 87.5%;\n}\n#cal-slide-tick.tick-day1 {\n  left: 7.14285714285715%;\n}\n#cal-slide-tick.tick-day2 {\n  left: 21.42857142857143%;\n}\n#cal-slide-tick.tick-day3 {\n  left: 35.71428571428572%;\n}\n#cal-slide-tick.tick-day4 {\n  left: 50%;\n}\n#cal-slide-tick.tick-day5 {\n  left: 64.2857142857143%;\n}\n#cal-slide-tick.tick-day6 {\n  left: 78.57142857142859%;\n}\n#cal-slide-tick.tick-day7 {\n  left: 92.85714285714285%;\n}\n#cal-slide-content ul.unstyled {\n  margin-bottom: 0;\n}\n.cal-week-box {\n  position: relative;\n}\n.cal-week-box [data-event-class] {\n  white-space: nowrap;\n  height: 30px;\n  margin: 1px 1px;\n  line-height: 30px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-left: 10px;\n}\n.cal-week-box .cal-column {\n  position: absolute;\n  height: 100%;\n  z-index: -1;\n}\n.cal-week-box .arrow-before,\n.cal-week-box .arrow-after {\n  position: relative;\n}\n.cal-week-box .arrow-after:after {\n  content: '';\n  position: absolute;\n  top: 0px;\n  width: 0;\n  height: 0;\n  right: 0;\n  border-top: 15px solid #ffffff;\n  border-left: 8px solid;\n  border-bottom: 15px solid #ffffff;\n}\n.cal-week-box .arrow-before:before {\n  content: '';\n  position: absolute;\n  top: 0px;\n  width: 0;\n  height: 0;\n  left: 1px;\n  border-top: 15px solid transparent;\n  border-left: 8px solid #ffffff;\n  border-bottom: 15px solid transparent;\n}\n#cal-day-box {\n  text-wrap: none;\n}\n#cal-day-box .cal-day-hour-part {\n  height: 30px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border-bottom: thin dashed #e1e1e1;\n}\n#cal-day-box .cal-day-hour .day-highlight {\n  height: 30px;\n}\n#cal-day-box .cal-hours {\n  font-weight: bolder;\n}\n#cal-day-box .cal-day-hour:nth-child(odd) {\n  background-color: #fafafa;\n}\n#cal-day-box #cal-day-panel {\n  position: relative;\n  padding-left: 60px;\n}\n#cal-day-box #cal-day-panel-hour {\n  position: absolute;\n  width: 100%;\n  margin-left: -60px;\n}\n#cal-day-box .day-event {\n  position: relative;\n  max-width: 200px;\n  overflow: hidden;\n}\n#cal-day-box .day-highlight {\n  line-height: 30px;\n  padding-left: 8px;\n  padding-right: 8px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border: 1px solid #c3c3c3;\n  margin: 1px 1px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n#cal-day-box .day-highlight.dh-event-important {\n  border: 1px solid #ad2121;\n}\n#cal-day-box .day-highlight.dh-event-warning {\n  border: 1px solid #e3bc08;\n}\n#cal-day-box .day-highlight.dh-event-info {\n  border: 1px solid #1e90ff;\n}\n#cal-day-box .day-highlight.dh-event-inverse {\n  border: 1px solid #1b1b1b;\n}\n#cal-day-box .day-highlight.dh-event-success {\n  border: 1px solid #006400;\n}\n#cal-day-box .day-highlight.dh-event-special {\n  background-color: #ffe6ff;\n  border: 1px solid #800080;\n}\n.event {\n  display: block;\n  background-color: #c3c3c3;\n  width: 12px;\n  height: 12px;\n  margin-right: 2px;\n  margin-bottom: 2px;\n  -webkit-box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.4);\n  box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.4);\n  border-radius: 8px;\n  border: 1px solid #ffffff;\n}\n.event-block {\n  display: block;\n  background-color: #c3c3c3;\n  width: 20px;\n  height: 100%;\n}\n.cal-event-list .event.pull-left {\n  margin-top: 3px;\n}\n.event-important {\n  background-color: #ad2121;\n}\n.event-info {\n  background-color: #1e90ff;\n}\n.event-warning {\n  background-color: #e3bc08;\n}\n.event-inverse {\n  background-color: #1b1b1b;\n}\n.event-success {\n  background-color: #006400;\n}\n.event-special {\n  background-color: #800080;\n}\n.day-highlight {\n  background-color: #dddddd;\n}\n.day-highlight.dh-event-important {\n  background-color: #fae3e3;\n}\n.day-highlight.dh-event-warning {\n  background-color: #fdf1ba;\n}\n.day-highlight.dh-event-info {\n  background-color: #d1e8ff;\n}\n.day-highlight.dh-event-inverse {\n  background-color: #c1c1c1;\n}\n.day-highlight.dh-event-success {\n  background-color: #caffca;\n}\n.day-highlight.dh-event-special {\n  background-color: #ffe6ff;\n}\n.cal-row-head [class*='cal-cell']:first-child,\n.cal-row-head [class*='cal-cell'] {\n  text-align: center;\n  border: 0px solid;\n  padding: 5px 0;\n}\n.cal-row-head [class*='cal-cell'] small {\n  font-weight: normal;\n}\n\n.cal-month-day {\n  height: 100px;\n}\n[class*='cal-cell']:hover {\n  background-color: #ededed;\n}\n.cal-row-fluid .week .cal-cell1.cal-cell,\n.cal-row-fluid .week .cal-cell1.cal-cell:hover {\n  background-color: #fff;\n  color: #000;\n}\n\n.cal-year-box [class*='span'],\n.cal-month-box [class*='cal-cell'] {\n  min-height: 13vh; /* was 100px sean neilan */\n  border-right: 1px solid #e1e1e1;\n  position: relative;\n}\n.cal-year-box [class*='span'] {\n  min-height: 60px;\n}\n.cal-year-box .row-fluid [class*='span']:last-child,\n.cal-month-box .cal-row-fluid [class*='cal-cell']:last-child {\n  border-right: 0px;\n}\n.cal-year-box .row-fluid,\n.cal-month-box .cal-row-fluid {\n  border-bottom: 1px solid #e1e1e1;\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.cal-year-box .row-fluid:last-child,\n.cal-month-box .cal-row-fluid:last-child {\n  border-bottom: 0px;\n}\n.cal-month-box,\n.cal-year-box,\n.cal-week-box {\n  border-bottom: 1px solid #e1e1e1;\n  border-left: 1px solid #e1e1e1;\n  border-radius: 2px;\n}\nspan[data-cal-date] {\n  font-size: 1.2em;\n  font-weight: normal;\n  opacity: 0.5;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.1s ease-in-out;\n  -moz-transition: all 0.1s ease-in-out;\n  -ms-transition: all 0.1s ease-in-out;\n  -o-transition: all 0.1s ease-in-out;\n  margin-top: 15px;\n  margin-right: 15px;\n}\nspan[data-cal-date]:hover {\n  opacity: 1;\n}\n.cal-day-outmonth span[data-cal-date] {\n  opacity: 0.1;\n  cursor: default;\n}\n.cal-day-today {\n  background-color: #e8fde7;\n}\n.cal-day-today span[data-cal-date] {\n  color: darkgreen;\n}\n.cal-month-box .cal-day-today span[data-cal-date] {\n  font-size: 1.9em;\n}\n.cal-day-holiday span[data-cal-date] {\n  color: #800080;\n}\n.cal-day-weekend span[data-cal-date] {\n  color: darkred;\n}\n#cal-week-box {\n  border: 1px solid #e1e1e1;\n  border-right: 0px;\n  border-radius: 5px 0 0 5px;\n  background-color: #fafafa;\n  text-align: right;\n}\n#cal-day-tick {\n  border: 1px solid #e1e1e1;\n  border-top: 0px solid;\n  border-radius: 0 0 5px 5px;\n  background-color: #ededed;\n  text-align: center;\n}\n#cal-slide-box {\n  border-top: 0px solid #8c8c8c;\n}\n#cal-slide-content {\n  padding: 20px;\n  color: #ffffff;\n  /* background-image: url(\"../img/dark_wood.png\"); */\n  -webkit-box-shadow: inset 0px 0px 15px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: inset 0px 0px 15px 0px rgba(0, 0, 0, 0.5);\n}\n#cal-slide-tick {\n  /* background-image: url(\"../img/tick.png?2\"); */\n}\n#cal-slide-content:hover {\n  background-color: transparent;\n}\n#cal-slide-content a.event-item {\n  color: #ffffff;\n  font-weight: normal;\n  line-height: 22px;\n}\n.cal-column {\n  border-left: 1px solid #e1e1e1;\n}\n\na.cal-event-week {\n  text-decoration: none;\n  color: #151515;\n}\n\n.border-box {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n.border-box {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n/**** Calendar related layout stuff ****/\n/* layout for the calendar and todo list*/\n.innerCalendarContainer {\n  display: flex;\n}\n\n#courseCalendarHolder {\n  width: 60%;\n}\n\n.calendar {\n  float: left;\n  display: block;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n.calendar div.header {\n  float: left;\n  width: 100%;\n  background: white !important;\n  height: 40px;\n  color: white;\n}\n\n.calendar div.header * {\n  height: 40px;\n  line-height: 40px !important;\n  display: inline-block;\n  float: left;\n  vertical-align: middle;\n}\n\n.calendar div.header i {\n  float: left;\n  width: 40px;\n  font-size: 1.125em;\n  font-weight: bold;\n  position: relative;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  padding: 0 11%;\n  cursor: pointer;\n}\n\n.calendar div.header i.fa-angle-left {\n  text-align: left;\n}\n\n.calendar div.header i.fa-angle-right {\n  text-align: right;\n}\n\n.calendar div.header div {\n  float: left;\n  width: 100%;\n  font-weight: bold;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  padding-left: 50px;\n  padding-right: 40px;\n  color: black;\n}\n\n/* Center the month selector */\n.calendar div.header div.nav {\n  display: flex;\n  justify-content: center;\n}\n\n/* Make the month name at the top huge */\n.calendar div.header div.nav span {\n  font-size: 2rem;\n}\n\n.calendar div.header .filtering {\n  float: right;\n  width: 30%;\n}\n\n.calendar div.header .filtering span {\n  display: block;\n  float: right;\n  margin-right: 15px;\n}\n\n/* Calendar row styling */\n.calendar .cal-month-box div.week {\n  border-right: solid 1px #e1e1e1;\n  border-left: solid 1px #e1e1e1;\n}\n.calendar div.week {\n  float: left;\n  width: 100%;\n  border-top: solid 1px #e1e1e1;\n  border-bottom: none;\n}\n.calendar div.week:first-child {\n  border-top: none;\n}\n.calendar div.week:last-child {\n  border-bottom: solid 1px #e1e1e1;\n}\n.calendar div.week .cal-cell.day:first-child {\n  border-left: none;\n}\n.calendar div.week > .day.today h5 {\n  color: #1eabe3;\n  font-weight: bold;\n}\n.calendar div.week .cal-cell.day.different-month {\n  color: #c0c0c0;\n}\n\n/* If you select a different month, the gray text will look bad\n * on most selectors, so, change it to black. this gets changed to white in the css.js service if the portalBackground color is too dark */\n.calendar div.week .cal-cell.day.different-month.selected {\n  color: black;\n}\n.calendar div.week .cal-cell.day.selected {\n  background: #e5e5e5;\n  outline: none;\n}\n.calendar div.week.names div {\n  color: #2875c7;\n}\n\n.calendar .calendarList .h3 a {\n  font-size: 24px;\n}\n\n/* Individual cell layout */\n.calendar div.week .cal-cell.day {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-bottom: 0rem;\n  padding-left: 0.5rem;\n  padding-top: 0.7rem;\n  padding-right: 0.5rem;\n}\n\n/* upper right todo bubble count */\n.calendar div.week .todoCount {\n  position: absolute;\n  top: -1rem;\n  right: -1rem;\n  width: 3rem;\n  height: 3rem;\n  background-color: #1eabe3;\n  border-radius: 10rem;\n  color: white;\n  font-weight: bold;\n  z-index: 1;\n  line-height: 30px;\n  -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.33);\n  -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.33);\n  box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.33);\n}\n\n/* Individual cell styling */\n.calendar .calendarCellItem {\n  text-align: left;\n  font-weight: bold;\n}\n.calendar .calendarCellItem span {\n  text-align: left;\n  font-weight: bold;\n  display: block;\n  overflow: hidden;\n  height: 5vh;\n}\n\n.calendar div.week > .day {\n  float: left;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  text-align: center;\n  height: 30px;\n  line-height: 30px !important;\n  display: inline-block;\n  vertical-align: middle;\n  background: white;\n  cursor: pointer;\n  color: black;\n}\n\n.calendar div.week > .day .content p {\n  margin: 0;\n  padding: 0px 0 3px 7px;\n  line-height: 16px;\n  font-size: 12px;\n}\n\n.calendar div.week > .day h5 {\n  margin: 3px;\n  text-align: left;\n}\n\n/**** Assignments list ****/\n/* Make sure the assignments list floats to the right */\n#courseCalendarAssignmentHolder {\n  /* Stored in calendar.html */\n  float: right;\n  display: flex;\n  width: 40%;\n  margin-left: 1rem;\n}\n\n#calendarAssignmentsList {\n  /* Background */\n  background-color: #e5e5e5;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 2rem;\n  overflow-y: scroll;\n  width: 100%;\n}\n\n#calendarAssignmentsList h2 {\n  color: black !important;\n  font-size: 2rem;\n  text-align: center;\n  font-family: sans-serif;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n#calendarAssignmentsList h3.dueDate {\n  color: black !important;\n  font-size: 4rem;\n  text-align: center;\n  font-family: sans-serif;\n  font-weight: bold;\n  border-bottom: 1px solid #cccccc;\n  padding-bottom: 3rem;\n\n  /* Technical debt from a similar\n    class called .dueDate in another file */\n  position: initial;\n  top: 0;\n}\n\n/* list style layout */\nul.todoList {\n  list-style: none;\n  padding-left: 1.5rem;\n  padding-top: 2.5rem;\n  padding-bottom: 1.5rem;\n}\n\nul.todoList li {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Assignment status styling */\nul.todoList li span.status {\n  font-weight: bold;\n  font-size: 14px;\n  font-style: italic;\n  width: 23%;\n}\n\n/* Assignment title */\nul.todoList li .title {\n  color: black;\n  font-size: 16px;\n\n  /* this combo makes it so we have a nice border on the left side */\n  border-left: 1px solid #cccccc;\n  padding-bottom: 30px;\n\n  padding-left: 5%;\n  font-weight: bold;\n  width: 75%;\n}\n\n/* ILT Schedule offering */\nul.todoList li a.schedule {\n  font-size: 12px;\n  display: block;\n  margin-top: 7px;\n}\n\nul.todoList li .sessions {\n  padding: 7px 0px 0px 15px;\n}\n\nul.todoList li .sessions li {\n  display: block;\n}\n\nul.todoList li .sessions li p {\n  font-size: 14px;\n  font-weight: normal;\n  width: 100%;\n}\n\n#calendarAssignmentsList .offeringDetailsTitle {\n  color: black;\n  font-size: 14px;\n  font-weight: bold;\n  width: 100%;\n}\n\n#calendarAssignmentsList .offeringDetailsValue {\n  color: black;\n  font-size: 14px;\n  width: 75%;\n  font-weight: normal;\n}\n\n#calendarAssignmentsList .dateList {\n  column-gap: 3px;\n}\n\n#calendarAssignmentsList .dateList .offeringDetailsTitle {\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
